import React, { useEffect } from 'react';
import { Col, List, Row, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Page from '../../components/Page/Page';
import { userSelector } from '../../redux/selectors/user';
import Title from '../../components/Page/Title';
import Paper from '../../components/Paper/Paper';
import { EnvironmentOutlined, InfoCircleOutlined, MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons';
import Banner from '../../components/Banner/Banner';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import { AppDispatch } from '../../types/store';
import { profileScreenOpen } from '../../utils/analytika/events';
import { colorBorder } from '../../styles/theme';

const ProfileV2 = () => {
  const { t } = useTranslation();
  const { userData } = useSelector(userSelector);
  const { xl: isXlBreakpoint, md: isMdBreakpoint } = useBreakpoint();
  const {
    user: { publishAnalytikaEvent }
  } = useDispatch<AppDispatch>();

  useEffect(() => {
    publishAnalytikaEvent(profileScreenOpen());
  }, []);

  const data: { title: string | JSX.Element; description: string; avatar: JSX.Element }[] = [
    { title: t('profile.name'), description: userData.name, avatar: <UserOutlined /> },
    { title: t('profile.email'), description: userData.email, avatar: <MailOutlined /> },
    { title: t('profile.phone'), description: userData.phone, avatar: <PhoneOutlined /> },
    { title: t('profile.city'), description: userData.city?.name || '-', avatar: <EnvironmentOutlined /> }
  ];
  return (
    <Page>
      {isMdBreakpoint && <Title text={t('profile.pageTitle')} />}
      <Paper>
        <Typography.Title type="secondary" level={4}>
          {t(`profile.accountTitle`)}
        </Typography.Title>
        <Row style={{ flexFlow: isXlBreakpoint ? 'row' : 'column-reverse' }} gutter={30}>
          <Col xl={14} lg={24}>
            <List
              dataSource={data}
              itemLayout="horizontal"
              renderItem={item => {
                const { title, description, avatar } = item;
                return (
                  <List.Item>
                    <List.Item.Meta
                      title={<Typography.Title level={4}>{title}</Typography.Title>}
                      description={description}
                      avatar={avatar}
                    />
                  </List.Item>
                );
              }}
            />
          </Col>
          <Col style={{ margin: isXlBreakpoint ? 'unset' : '20px 0' }} xl={10} lg={24}>
            <Banner
              type="info"
              showIcon
              style={{ borderColor: colorBorder }}
              icon={<InfoCircleOutlined />}
              message={t('profile.banner')}
            />
          </Col>
        </Row>
      </Paper>
    </Page>
  );
};

export default ProfileV2;
